module.exports = __webpack_public_path__ + "static/img/activate2.8478778.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activate2.svg
// module id = 1434
// module chunks = 180